<div class="container-fluid px-0">
  <div class="row  mx-0 my-0 h-100">
    <div class="ie">
      <div *ngIf="description != null" [ngStyle]="{'width.px': width}"
           class="col-12 px-0 d-flex message-content">
        <span class="message">{{description}}</span>
        <img class="close-logo" [src]="'assets/images/png/close.png'" [srcset]="'assets/images/png/close@2x.png 2x, assets/images/png/close@3x.png 3x'" (click)="close()" alt="logo"/>
      </div>
    </div>
  </div>
</div>
